import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { routes } from '../../shared/routes/routes';
import { TokenService } from './token.service';
import { Roles } from '../constants/roles';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private userClaims: string[] = [];
  
  constructor(
    private tokenService: TokenService
  ) { 
    this.initializeSession();
  }

  /**
   * تهيئة الجلسة (الـ Claims والـ Section المبدئي)
   */
  public initializeSession(): void {
    
    const tokenData = this.tokenService.decodeToken();
    if (tokenData) {
      
      if (tokenData.claims) {
        this.userClaims = Array.isArray(tokenData.claims) ? tokenData.claims : [tokenData.claims];
      }
      
      if (tokenData.category) {
        const categories = Array.isArray(tokenData.category) ? tokenData.category : [tokenData.category];
        const currentSection = this.getSelectedSection();
        
        // إذا كان السيكشن المخزن غير موجود في صلاحيات المستخدم الجديدة، نختار أول سيكشن متاح
        if (!currentSection || !categories.includes(currentSection)) {
          this.setSelectedSection(categories[0]);
        }
      }
    }
  }

  /**
   * التحقق من وجود claim معين
   */
  public hasClaim(claim: string): boolean {
    return this.userClaims.includes(claim);
  }

  /**
   * الحصول على جميع الـ Claims
   */
  public getUserClaims(): string[] {
    return this.userClaims;
  }

  private collapseSubject = new BehaviorSubject<boolean>(false);
  collapse$ = this.collapseSubject.asObservable();

  // للتحكم في الـ section المختار
  private selectedSectionSubject = new BehaviorSubject<string>(
    localStorage.getItem('selectedSection') || ''
  );
  public selectedSection$ = this.selectedSectionSubject.asObservable();

  toggleCollapse() {
    this.collapseSubject.next(!this.collapseSubject.value);
  }

  /**
   * تغيير الـ section المختار
   */
  public setSelectedSection(section: string): void {
    
    localStorage.setItem('selectedSection', section);
    this.selectedSectionSubject.next(section);
  }

  /**
   * الحصول على الـ section الحالي
   */
  public getSelectedSection(): string {
    return this.selectedSectionSubject.value;
  }

  public sidebarData1: any[] = [
    
    {
      tittle: 'Btakka Home',
      section: 'BtakkaInterface', // الـ section الخاص بهذا القسم
      showAsTab: true,
      separateRoute: false,
      menu: [
        {
          menuValue: 'Profile',
          icon: 'user',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.home,
          base: 'home',
          subRoutes: [],
        },
        {
          menuValue: 'Inspection Request',
          claim: 'FinishingInseption', // الـ claim المطلوب
          icon: 'clipboard-check',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.FinishingInspectionRequest,
          base: 'FinishingInspectionRequest',
          subRoutes: [],
        },
        {
          menuValue: 'Contract Request',
          claim: 'CompanyService', // الـ claim المطلوب
          icon: 'file-text',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.ContractRequest,
          base: 'ContractRequest',
          subRoutes: [],
        },
        {
          menuValue: 'Planes',
          claim: 'Plan', // الـ claim المطلوب
          icon: 'list-details',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.Planes,
          base: 'Planes',
          subRoutes: [],
        }
      ],
    },
    {
      tittle: 'Btakka ERP',
      section: 'BtakkaErp', // الـ section الخاص بهذا القسم
      showAsTab: true,
      separateRoute: false,
      menu: [
        {
          menuValue: 'Accounts',
          claim: 'ManageAccounts', // الـ claim المطلوب
          icon: 'users',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.accountsGrid,
          base: 'accounts',
          subRoutes: [],
        },
        {
          menuValue: 'Cost Center',
          claim: 'CostCenter', // الـ claim المطلوب
          icon: 'wallet',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.CostCenter,
          base: 'CostCenter',
          subRoutes: [],
        },
        {
          menuValue: 'Journal Type',
          icon: 'calendar-event',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.journalType,
          base: 'Journal-Type',
          subRoutes: [],
        }
      ],
    },
    {
      tittle: 'Operation',
      section: 'BtakkaOperation', 
      showAsTab: true,
      separateRoute: false,
      menu: [
        {
          menuValue: 'Home',
          claim: 'Settlement', 
          icon: 'home',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.Settling,
          base: 'Settling',
          subRoutes: [],
        },
        {
          menuValue: 'Unit',
          claim: 'UnitsTotalBalance', 
          icon: 'building',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.OperationUnit,
          base: 'Operation',
          subRoutes: [],
        },
        {
          menuValue: 'Engineer',
          claim: 'EngineersTotalBalance', 
          companyOnly: true,
          icon: 'user-check',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.OperationEngineer,
          base: 'Operation',
          subRoutes: [],
        },
        {
          menuValue: 'Management',
          claim: 'Management', 
          companyOnly: true,
          icon: 'settings-automation',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.Management,
          base: 'Management',
          subRoutes: [],
        }
      ]
    },
    {
      tittle: 'More',
      showDivider: true,
      showAsTab: false,
      separateRoute: false,
      menu: [
        {
          menuValue: 'About',
          icon: 'info-circle',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.About,
          base: 'About',
          subRoutes: [],
        },
        {
          menuValue: 'Faqs',
          icon: 'help',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.Faqs,
          base: 'Faqs',
          subRoutes: [],
        },
        {
          menuValue: 'Privacy Policy',
          icon: 'shield',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.PrivacyPolicy,
          base: 'PrivacyPolicy',
          subRoutes: [],
        },
        {
          menuValue: 'Terms & Conditions',
          icon: 'file-description',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.TermsConditions,
          base: 'TermsConditions',
          subRoutes: [],
        }
      ]
    }
  ];

  /**
   * الحصول على الـ sidebar المفلتر بناءً على الـ Section والـ Claims
   */
  public getFilteredSidebarData(selectedSection?: string): any[] {
    const section = selectedSection || this.getSelectedSection();
    const decoded = this.tokenService.decodeToken();
    const isEngineer = decoded?.roles === Roles.Engineer;

    const filtered = this.sidebarData1
      .filter(sidebarSection => {
        // فلتر بناءً على الـ section المختار
        if (!sidebarSection.section) return true;
        const match = sidebarSection.section === section;
        return match;
      })
      .map(sidebarSection => {
        const filteredMenu = sidebarSection.menu.filter((menuItem: any) => {
          // العناصر المخصصة لـ Company فقط
          if (menuItem.companyOnly && isEngineer) return false;
          // المهندس يرى باقي عناصر الـ Operation بدون فلتر claims
          if (isEngineer) return true;
          // إذا لم يكن هناك claim محدد، اعرض العنصر
          if (!menuItem.claim) return true;
          // إذا كان هناك claim، تحقق من وجوده
          const has = this.hasClaim(menuItem.claim);
          return has;
        });

        return {
          ...sidebarSection,
          menu: filteredMenu
        };
      })
      .filter(sidebarSection => sidebarSection.menu.length > 0); // احذف الأقسام الفارغة
    
    return filtered;
  }
}
